export default __webpack_public_path__ + "static/947-0b779e56e80bffb674360914563bbd00.gif";